import React from 'react';

/**
 * DataOps Catalog Help Content
 */
const CatalogHelp: React.FC = () => {
  return (
    <>
      <div>
        <h3 className="text-base font-semibold text-gray-900 dark:text-white mb-2">
          Data Catalog
        </h3>
        <p className="text-sm text-gray-600 dark:text-gray-400 leading-relaxed">
          The Data Catalog is your central repository for discovering, understanding, and managing all data assets across your organization. Browse tables, views, datasets, and other data sources with rich metadata.
        </p>
      </div>

      <div>
        <h3 className="text-base font-semibold text-gray-900 dark:text-white mb-2">
          Browsing Assets
        </h3>
        <div className="space-y-2 text-sm text-gray-600 dark:text-gray-400">
          <p>&#8226; <span className="font-medium">Asset List</span>: View all tables, views, and data sources in your environment</p>
          <p>&#8226; <span className="font-medium">Filtering</span>: Filter by type, source, owner, or tags to narrow down results</p>
          <p>&#8226; <span className="font-medium">Sorting</span>: Sort by name, last updated, or popularity</p>
          <p>&#8226; <span className="font-medium">Favorites</span>: Mark frequently accessed assets for quick access</p>
        </div>
      </div>

      <div>
        <h3 className="text-base font-semibold text-gray-900 dark:text-white mb-2">
          Search Capabilities
        </h3>
        <p className="text-sm text-gray-600 dark:text-gray-400 leading-relaxed mb-3">
          Quickly find specific assets using powerful search:
        </p>
        <div className="space-y-2 text-sm text-gray-600 dark:text-gray-400">
          <p>&#8226; <span className="font-medium">Full-text search</span>: Search by asset name, description, or column names</p>
          <p>&#8226; <span className="font-medium">Tag search</span>: Find assets by their assigned tags</p>
          <p>&#8226; <span className="font-medium">Advanced filters</span>: Combine multiple criteria for precise results</p>
        </div>
      </div>

      <div>
        <h3 className="text-base font-semibold text-gray-900 dark:text-white mb-2">
          Asset Details
        </h3>
        <p className="text-sm text-gray-600 dark:text-gray-400 leading-relaxed mb-3">
          Click on any asset to view detailed information:
        </p>
        <div className="space-y-2 text-sm text-gray-600 dark:text-gray-400">
          <p>&#8226; <span className="font-medium">Schema</span>: View column names, data types, and constraints</p>
          <p>&#8226; <span className="font-medium">Metadata</span>: Access descriptions, owners, and business context</p>
          <p>&#8226; <span className="font-medium">Statistics</span>: Review data quality metrics and usage patterns</p>
          <p>&#8226; <span className="font-medium">Lineage</span>: Navigate to upstream and downstream dependencies</p>
        </div>
      </div>

      <div>
        <h3 className="text-base font-semibold text-gray-900 dark:text-white mb-2">
          Managing Metadata
        </h3>
        <div className="space-y-2 text-sm text-gray-600 dark:text-gray-400">
          <p>&#8226; <span className="font-medium">Add descriptions</span>: Document assets and columns for better understanding</p>
          <p>&#8226; <span className="font-medium">Assign tags</span>: Categorize assets for easier discovery</p>
          <p>&#8226; <span className="font-medium">Set ownership</span>: Define data stewards and responsible teams</p>
        </div>
      </div>

    </>
  );
};

export default CatalogHelp;
